import axios from "axios";

const cleanBase = (u) => (u || "").replace(/\/+$/, "") + "/";

const errMsg = (e) => {
    const d = e?.response?.data;
    if (typeof d === "string") return d;
    if (d?.detail) return d.detail;
    if (d?.message) return d.message;
    return e?.message || "Unknown error";
};

export async function apiGetToken(baseUrl, username, password) {
    // POST {BASE_URL}/get-token/ :contentReference[oaicite:2]{index=2}
    try {
        const res = await axios.post(`${cleanBase(baseUrl)}get-token/`, { username, password });
        return res.data;
    } catch (e) {
        throw new Error(errMsg(e));
    }
}

export async function apiCreateLoan(baseUrl, token, body) {
    // POST {BASE_URL}/LSPLoan/create-loan/ :contentReference[oaicite:3]{index=3}
    try {
        const res = await axios.post(`${cleanBase(baseUrl)}LSPLoan/create-loan/`, body, {
            headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        });
        return res.data;
    } catch (e) {
        throw new Error(errMsg(e));
    }
}

export async function apiLoanStatus(baseUrl, token, partnerLoanId) {
    // GET {BASE_URL}/LSPLoan/{partner_loan_id}/loan-status/ :contentReference[oaicite:4]{index=4}
    try {
        const res = await axios.get(
            `${cleanBase(baseUrl)}LSPLoan/${encodeURIComponent(partnerLoanId)}/loan-status/`,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return res.data;
    } catch (e) {
        throw new Error(errMsg(e));
    }
}

export async function apiRepaymentSchedule(baseUrl, token, partnerLoanId, startDate) {
    // GET .../get-repayment-schedule/?start_date=... :contentReference[oaicite:5]{index=5}
    try {
        const res = await axios.get(
            `${cleanBase(baseUrl)}LSPLoan/${encodeURIComponent(partnerLoanId)}/get-repayment-schedule/`,
            { headers: { Authorization: `Bearer ${token}` }, params: { start_date: startDate } }
        );
        return res.data;
    } catch (e) {
        throw new Error(errMsg(e));
    }
}

export async function apiInitiateNach(baseUrl, token, partnerLoanId, body) {
    // POST .../initiate-nach/ :contentReference[oaicite:6]{index=6}
    try {
        const res = await axios.post(
            `${cleanBase(baseUrl)}LSPLoan/${encodeURIComponent(partnerLoanId)}/initiate-nach/`,
            body,
            { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
        );
        return res.data;
    } catch (e) {
        throw new Error(errMsg(e));
    }
}

export async function apiCreateAgreement(baseUrl, token, partnerLoanId) {
    // POST .../create-agreement/ :contentReference[oaicite:7]{index=7}
    try {
        const res = await axios.post(
            `${cleanBase(baseUrl)}LSPLoan/${encodeURIComponent(partnerLoanId)}/create-agreement/`,
            {},
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return res.data;
    } catch (e) {
        throw new Error(errMsg(e));
    }
}

export async function apiLoanDetails(baseUrl, token, partnerLoanId) {
    // GET .../loan-details/ :contentReference[oaicite:8]{index=8}
    try {
        const res = await axios.get(
            `${cleanBase(baseUrl)}LSPLoan/${encodeURIComponent(partnerLoanId)}/loan-details/`,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return res.data;
    } catch (e) {
        throw new Error(errMsg(e));
    }
}

export async function apiUploadDocuments(baseUrl, token, partnerLoanId, docType, file) {
    // POST .../upload-documents/ (form-data) :contentReference[oaicite:9]{index=9}
    try {
        const fd = new FormData();
        fd.append("doc_type", docType);
        fd.append("file", file);

        const res = await axios.post(
            `${cleanBase(baseUrl)}LSPLoan/${encodeURIComponent(partnerLoanId)}/upload-documents/`,
            fd,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return res.data;
    } catch (e) {
        throw new Error(errMsg(e));
    }
}

export async function apiRetrieveDocuments(baseUrl, token, partnerLoanId) {
    // GET .../retrieve-documents/ :contentReference[oaicite:10]{index=10}
    try {
        const res = await axios.get(
            `${cleanBase(baseUrl)}LSPLoan/${encodeURIComponent(partnerLoanId)}/retrieve-documents/`,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return res.data;
    } catch (e) {
        throw new Error(errMsg(e));
    }
}

export async function apiViewAgreement(baseUrl, token, partnerLoanId) {
    // GET .../view-agreement/ returns URL string :contentReference[oaicite:11]{index=11}
    try {
        const res = await axios.get(
            `${cleanBase(baseUrl)}LSPLoan/${encodeURIComponent(partnerLoanId)}/view-agreement/`,
            { headers: { Authorization: `Bearer ${token}` } }
        );
        return res.data;
    } catch (e) {
        throw new Error(errMsg(e));
    }
}

export async function apiInitiateUpiPayment(baseUrl, token, partnerLoanId, amount) {
    // POST .../initiate-upi-payment/ :contentReference[oaicite:12]{index=12}
    try {
        const res = await axios.post(
            `${cleanBase(baseUrl)}LSPLoan/${encodeURIComponent(partnerLoanId)}/initiate-upi-payment/`,
            { amount },
            { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
        );
        return res.data;
    } catch (e) {
        throw new Error(errMsg(e));
    }
}

export async function apiGetPayment(baseUrl, token, partnerLoanId, paymentId) {
    // GET .../get-payment/?payment_id=... :contentReference[oaicite:13]{index=13}
    try {
        const res = await axios.get(
            `${cleanBase(baseUrl)}LSPLoan/${encodeURIComponent(partnerLoanId)}/get-payment/`,
            { headers: { Authorization: `Bearer ${token}` }, params: paymentId ? { payment_id: paymentId } : {} }
        );
        return res.data;
    } catch (e) {
        throw new Error(errMsg(e));
    }
}
